import React from 'react'
import "./style.css"

export default function TextLoader(props) {
    var stringLabel = props.name?.split("")

    return (
        <div className="waviy">
            {
                stringLabel?.map(function (item, index) {
                    return <span style={{ "--i": index + 1 }}>{item}</span>
                })
            }
        </div>
    )
}
